import * as React from "react";
import ReactDOM from "react-dom";
import NewsletterRegistrationPage from "./NewsletterRegistrationPage";

export class NewsletterRegistrationPagePortal {
  public static run(element: HTMLElement): void {
    ReactDOM.render(
      <React.Suspense
        fallback={
          <div>
            <div className="swiper-lazy-preloader">{/* Empty */}</div>
          </div>
        }
      >
        <NewsletterRegistrationPage />
      </React.Suspense>,
      element,
    );
  }
}

export default NewsletterRegistrationPagePortal;
